async function parse(sitemapUrl) {
    const response = await fetch(sitemapUrl);
    const body = await response.text();
    return new DOMParser().parseFromString(body.trim(), "application/xml");
}
export { parse };
